import BaseAPI from '@/apis/base/baseApi';

class UserAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'user';
}

export default new UserAPI();
